<template lang="pug">
  article.post(v-if="item" :class="{ 'standalone': standalone, 'loaded': loaded }" :style="{ 'max-width': `${this.standalone ? this.mediaMaxWidth + 320 : this.mediaMaxWidth}px` }")
    header.header(:class="{ 'tablet': standalone}")
      .actions
        el-dropdown(trigger="click" size="small" placement="bottom-start" @command="handleCommand")
          .more-action
            i.el-icon-more
          el-dropdown-menu(slot="dropdown")
            el-dropdown-item(command="share") Share post
            el-dropdown-item(command="view") View post
            el-dropdown-item(command="cancel") Cancel
      user-info(:user="item.user")
    
    .media(@click="viewPost()")
      img(ref="mediaImage" :src="`${cdnURL}/members/uploads/large/${item.data}`")

    transition(name="fade" appear)
      .info
        header.header.not-tablet(v-if="standalone")
          .actions
            el-dropdown(trigger="click" size="small" placement="bottom-start" @command="handleCommand")
              .more-action
                i.el-icon-more
              el-dropdown-menu(slot="dropdown")
                el-dropdown-item(command="share") Share post
                el-dropdown-item(command="view") View post
                el-dropdown-item(command="cancel") Cancel
          user-info(:user="item.user")
        transition(name="fade")
          .likes-wrapper(v-if="showLikes")
            .likes
              avatar(v-for="like in item.likes" :key="like.id" :user="like.user" :size="30" :hover="false")
              .spacing
              .clearfix
        
        .controls
          v-touch.like-count(v-if="item.like_count > 0" @tap="showLikes = !showLikes" :class="{ 'active': showLikes }")
            span {{ item.like_count }}
            icon(icon="heart" size="xs")
          .clearfix

        .caption
          .meta
            .user {{ item.user.fullname || "Someone" }}
            .timestamp {{ item.created | timeago }}
            .clearfix
          .text
            el-popover(v-if="item.description.length > 60" placement="bottom-start" width="300" trigger="click")
              span {{ item.description || "No caption" }}
              span(slot="reference") {{ item.description || "No caption" | trim(60) }}
            span(v-else) {{ item.description || "No caption" | trim(60) }}

        .comments-wrapper
          .comments
        
        .composer
          el-input(type="text" placeholder="Add a comment")
          .post-button Post

</template>

<script>
// ES6
import resize from "vue-resize-directive";
import Moment from "moment-mini";

// Components
import UserInfo from "@/components/feed/UserInfo";
import Avatar from "@/components/Avatar";

export default {
  name: "Post",
  directives: {
    resize
  },
  components: {
    UserInfo,
    Avatar
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    standalone: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    trim: function(value, length) {
      if (value.length < length) return value;
      return `${value.substring(0, length)}...`;
    },
    timeago: function(value) {
      if (!value) {
        return "More than 5 ago";
      }
      return Moment(value).fromNow();
    }
  },
  computed: {
    postStyles() {
      return {
        "max-width": `${
          this.standalone ? this.mediaMaxWidth + 320 : this.mediaMaxWidth
        }px`
      };
    }
  },
  mounted() {
    setTimeout(() => {
      this.setMediaSize();
      this.$nextTick(() => {
        this.loaded = true;
      });
    }, 200);
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  updated() {
    setTimeout(() => {
      this.setMediaSize();
    }, 200);
  },
  data() {
    return {
      cdnURL: process.env.VUE_APP_CDN_URL,
      showLikes: false,
      mediaMaxWidth: 1000,
      loaded: false
    };
  },
  methods: {
    resizeHandler() {
      this.setMediaSize();
    },
    setMediaSize() {
      if (!this.$refs.mediaImage) return;
      this.mediaMaxWidth = 1000;
      this.$nextTick(() => {
        this.mediaMaxWidth = this.getMediaMaxWidth();
      });
    },
    getMediaMaxWidth() {
      const naturalHeight = parseInt(this.$refs.mediaImage.naturalHeight);
      const naturalWidth = parseInt(this.$refs.mediaImage.naturalWidth);
      const clientHeight = this.$refs.mediaImage.clientHeight;
      const ratio = clientHeight / naturalHeight;
      return ratio * naturalWidth;
    },
    handleCommand(command) {
      switch (command) {
        case "view":
          this.viewPost();
          break;

        default:
          break;
      }
    },
    viewPost() {
      this.$router.push({ name: "post", params: { id: this.item.id } });
    }
  }
};
</script>

<style lang="stylus">
article.post {
  animate(opacity);
  border-radius();
  border: $color-light-border 1px solid;
  align-items: stretch;
  align-content: stretch;
  background-color: white;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin: 0 auto;
  margin-bottom: 20px;
  min-height: 300px;
  overflow: hidden;
  position: relative;
  opacity: 0;
  pointer-events: none;

  &.loaded {
    opacity: 1;
    pointer-events: all;
  }

  +mobile() {
    width: 100%;
    float: none;
  }

  +mobile() {
    border-radius(0);
    border-left: none;
    border-right: none;
    margin-bottom: 100px;
  }

  .header {
    display: block;
    height: 60px;
    width: 100%;

    +tabletup() {
      border-bottom: $color-light-border 1px solid;

      &.tablet {
        display: none !important;
      }

      &.not-tablet {
        display: block !important;
      }
    }

    +tablet() {
      flex-basis: 100%;
      flex-grow: 1;
      order: 0;

      &.tablet {
        display: block !important;
      }

      &.not-tablet {
        display: none !important;
      }
    }
  }

  &.standalone .media {
    max-width: calc(100% - 320px) !important;

    +tablet() {
      max-width: calc(100%) !important;
    }
  }

  .media {
    flex-basis: $feed-width;
    flex-grow: 1;
    max-width: 100%;
    order: 0;

    +tablet() {
      background-color: white;
      flex-basis: 100%;
      max-width: 100% !important;
      order: 1;
    }
  }

  &.standalone .info {
    max-width: 100% !important;
  }

  .info {
    display: flex;
    flex-basis: 220px;
    flex-direction: column;
    flex-wrap: nowrap;
    flex-grow: 1;
    max-height: auto;
    word-break: break-all;
    order: 2;

    +tablet() {
      max-width: 100%;
    }
  }

  +tablet() {
    flex-direction: column;
  }

  .actions {
    pinned-tr(absolute, 10px);

    .more-action {
      border-radius();
      padding: 9px 15px;

      &:hover {
        cursor: pointer;
        background-color: $color-lightest-grey;
      }
    }
  }

  .media {
    display: block;
    position: relative;
    overflow: hidden;

    img {
      display: block;
      margin: 0 auto;
      position: relative;
      max-height: 80vh;
      max-width: 100%;
      z-index: 1;
    }
  }

  .controls {
    display: block;
    text-align: left;

    .like-count {
      animate();
      border-radius(10px);
      background-color: alpha(black, 0.5);
      color: white;
      float: left;
      line-height: 20px;
      margin: 20px;
      margin-bottom: 0;
      font-size: 0.7em;
      font-weight: bold;
      padding: 0 10px;

      svg {
        margin-left: 3px;
      }

      &.active {
        background-color: $color-like;
      }

      &:hover {
        background-color: $color-like;
        cursor: pointer;
        transform: scale(1.1);
      }
    }
  }

  .likes-wrapper {
    border-bottom: $color-light-border 1px solid;
    flex-grow: 0;
    position: relative;
    flex-basis: 150px;

    .likes {
      pinned(absolute);
      overflow-y: auto;
      padding: 18px;

      .avatar {
        float: left;
        margin: 2px;
      }
    }
  }

  .caption {
    flex-grow: 2;
    height: 100px;
    overflow: hidden;
    text-align: left;
    line-height: 20px;

    .meta {
      padding: 20px;
      padding-bottom: 0;
      line-height: inherit;

      .user {
        float: left;
        font-weight: bold;
        line-height: inherit;
      }

      .timestamp {
        color: $color-text-subheading;
        float: right;
        font-size: 0.8em;
        line-height: inherit;
      }
    }

    .text {
      line-height: inherit;
      padding: 20px;
      padding-top: 5px;
    }
  }

  .comments-wrapper {
    flex-grow: 1;
    position: relative;

    .comments {
      pinned(absolute);
      overflow-y: auto;
    }
  }

  .composer {
    border-top: $color-light-border 1px solid;
    padding: 5px;
    position: relative;

    .el-input__inner {
      border: none !important;
    }

    .post-button {
      pinned-tr(absolute);
      color: $color-info;
      font-size: 0.9em;
      font-weight: bold;
      line-height: 20px;
      padding: 15px 20px;
      opacity: 0.6;
    }
  }
}
</style>
